import { LoginStep } from "./types.ts";

export const removeQueryParams = () => {
  const url = new URL(window.location.href);
  url.search = "";
  window.history.replaceState({}, "", url.toString());
};

export const LOGIN_TITLE_MAP: Record<LoginStep, string> = {
  initial: "Welcome Back",
  password: "Welcome back",
  verification: "Welcome back",
  emailUserInfo: "Tell us about you",
};
